import {Dimensions, StyleSheet} from 'react-native';
const windowHeight = Dimensions.get('window').height;
export const styles = StyleSheet.create({
  bold: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  displayHorizontal: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
  },
  btnStyles: {
    paddingHorizontal: 1,
    marginHorizontal: 5,
    minWidth: 1,
  },
  btnStylesTxt: {
    paddingHorizontal: 10,
    margin: 0,
    fontSize: 14,
  },
  modalBlock: {
    backgroundColor: 'rgba(0, 0, 0, .8)',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 999999,
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  webModal: {
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
    width: '100%',
    height: windowHeight,
    borderColor: 'transparent',
    borderWidth: 0,
    position: 'relative',
    zIndex: 99999,
  },
  modalView: {
    margin: 20,
    backgroundColor: 'white',
    borderRadius: 20,
    paddingHorizontal: 20,
    paddingVertical: 35,
    minWidth: 300,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  modalText: {
    fontSize: 16,
    fontWeight: '400',
    marginBottom: 15,
    textAlign: 'center',
    maxWidth: 300,
  },
});
